import { render, staticRenderFns } from "./ProctoringLocation.vue?vue&type=template&id=200751e9&scoped=true&"
import script from "./ProctoringLocation.vue?vue&type=script&lang=js&"
export * from "./ProctoringLocation.vue?vue&type=script&lang=js&"
import style0 from "./ProctoringLocation.vue?vue&type=style&index=0&id=200751e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200751e9",
  null
  
)

export default component.exports